import React from "react";
import {
  apiPaths,
  postData,
} from "../../platform-components/api-integration-util";
import logo from "../../../images/logo.png";
import { getRoleNameList, getUserDetails } from "../utils/shared-data.service";
import { hasCategoryAccess, getStoredPermissions } from "../utils/permission.service";
import { useHistory } from "react-router-dom";
import GlobalQuestionSearch from "./GlobalQuestionSearch";
import "./GlobalQuestionSearch.scss";

function AppHeader(props) {
  const history = useHistory();
  const logOut = async () => {
    try {
      await postData(apiPaths.logout, { data: {} });
    } catch (e) {
    }
    localStorage.clear();
    try {
      history.push('/login');
    } catch (e) {
    }
    window.location.reload();
  };

  const handleChangePass = () => props.history.push("/app/change-password");

  return (
    <div>
      <header className="main-header">
        <div className="logo">
          <span className="logo-mini">
            <img src={logo} alt="Arise Medical Academy" style={{ height: 30, width: 'auto' }} />
          </span>
          <span className="logo-lg">
            <img src={logo} alt="Arise Medical Academy" style={{ height: 36, width: 'auto' }} />
          </span>
        </div>
        <nav className="navbar navbar-static-top">
          <div className="sidebar-toggle" data-toggle="offcanvas" role="button">
            <span className="sr-only">Toggle navigation</span>
          </div>

          <GlobalQuestionSearch />

          <div className="navbar-custom-menu">
            <ul className="nav navbar-nav">
              <li className="dropdown user user-menu">
                <div className="dropdown-toggle" data-toggle="dropdown">
                  <div className="login-details-navbar">
                    <div className="login-first-letter">
                      {getUserDetails().firstName?.charAt(0)?.toUpperCase() ||
                        "A"}
                    </div>
                  </div>
                </div>
                <ul className="dropdown-menu">
                  {(getStoredPermissions()['Admin Panel'] !== undefined
                    ? hasCategoryAccess("Admin Panel")
                    : getRoleNameList().includes("Admin")) && (
                    <li
                      className="dropdown-item"
                      onClick={() => props.history.push("/app/adminPanel")}
                    >
                      <span role="button">
                        {getUserDetails().firstName || "Admin"}
                      </span>
                    </li>
                  )}
                  <div class="dropdown-divider"></div>
                  <li className="dropdown-item" onClick={handleChangePass}>
                    <span role="button">Change Password</span>
                  </li>
                  <div class="dropdown-divider"></div>
                  <li className="dropdown-item" onClick={logOut}>
                    <span role="button">Logout</span>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </nav>
      </header>
    </div>
  );
}
export default AppHeader;
